export const ARCADE_LIST__SET_ARCADE_SEARCH_RESULTS = 'ARCADE_LIST__SET_ARCADE_SEARCH_RESULTS';

export const GET_ARCADES = 'API_FETCH__GET_ARCADES';
